import { API, api } from "@/lib/api";

export const coverUrl = (c) => (c?.cover_file_id ? `${API}/files/${c.cover_file_id}` : c?.cover_image_url || null);

export const fileUrl = (id) => `${API}/files/${id}`;

export function videoEmbed(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
}

export async function downloadFile(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const TRAINING_STATUS = {
  not_started: { label: "Not started", cls: "bg-zinc-100 text-zinc-600 border-zinc-200" },
  in_progress: { label: "In progress", cls: "bg-lasso-tint text-lasso-deep border-lasso-sky/60" },
  completed: { label: "Completed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  needs_reack: { label: "Re-acknowledge", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  retraining_due: { label: "Retraining due", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};
